import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { GrantsAuthorizedSigneeAndPayeeViewModalComponent } from './grants-authorized-signee-and-payee-view-modal/grants-authorized-signee-and-payee-view-modal.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { UserService } from "src/app/services/user.service";
import { AdvModel, Model } from 'src/app/models/common';

@Component({
  selector: "app-grants-authorized-signee-and-payee",
  templateUrl: "./grants-authorized-signee-and-payee.component.html",
  styleUrls: ["./grants-authorized-signee-and-payee.component.scss"],
})
export class GrantsAuthorizedSigneeAndPayeeComponent implements OnInit {
  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  tempoperations;
  userType: string;
  advanceSearch;
  appid: string;
  staticformFields: any;
  permission: string;
  userForm: UntypedFormGroup;
  collapesedOrNot: Boolean = false;
  screencode: string;
  dynomessage: string = "";
  permissionCode: string;
  ScreenName:string = '';

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService,
    private userService: UserService,
  ) {
    this.screencode = route.snapshot.params["code"];
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid )
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.columnDefs = [
          {
            headerName: "Name",
            field: "NAME",
            sortable: true,
          },
          {
            headerName: this.staticformFields?.EMAIL.LABEL_NAME,
            field: "EMAIL",
            sortable: true,
          },
          {
            headerName: this.staticformFields?.IS_DEFAULT_CONTACT?.LABEL_NAME,
            field: "DefaultContact",
            //sortable: true,
          },
        ];
      });
  }
  ngOnInit() {
    var grantapp = this.commonService.getGrantsApp();
    // this.appid = grantapp?.ID;
    this.appid = this.commonService.appId;
    this.getStaticFiledsData('SCR-028');
    this.userType = this.userService.getUserType();
    this.setSummary();

    //this.NavigateToGenInfo();
    this.userForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
    });
    this.columnDefs = [
      {
        headerName: "Name",
        field: "NAME",
        sortable: true,
      },
      {
        headerName: "E-mail",
        field: "EMAIL",
        sortable: true,
      },
      {
        headerName: "Default Signee",
        field: "DefaultContact",
        sortable: true,
      },
    ];
    this.advanceSearch = {
      fields: [
        {
          label: "Name",
          field: "simple",
          type: "text",
        },
      ],
      filters: [],
    };
    this.tempoperations = [];
    
    //this.permission = "";
    this.screencode = "authorized_signee_and_payee";
    if (this.screencode != null && this.screencode != undefined)
      this.screencode = this.screencode.toLowerCase();
      this.permissionCode = "GC07";
    // if (grantapp.GRANT_TYPE == 1) this.permissionCode = "GC07";
    // else if (grantapp.GRANT_TYPE == 2) this.permissionCode = "GCH03";
    // else if (grantapp.GRANT_TYPE == 3) this.permissionCode = "GSP05";

   this.permission = this.commonService.getPagePermission("GC07").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == ''){
       const intervalId = setInterval(() => {
         this.permission = this.commonService.getPagePermission("GC07").toLowerCase();
         if (this.permission != null && this.permission != undefined && this.permission != '') {
           clearInterval(intervalId);
            this.ScreenPermissionData();
         }
       }, 1000);
   }
   else{
    this.ScreenPermissionData();
   }
    this.GetScreenConfigControls('SCR-028');
  }

  ScreenPermissionData() {
    if (this.permission == 'new') {
      this.operations = [{
        name: "Add",
        id: "add",
      }].map((operation) => {
        return operation &&
          (operation.id === "add" || operation.id === "view_modal")
          ? {
            name: operation.name,
            callback: this[operation.id],
            self: this,
            disabled: "false",
          }
          : { name: operation.name, callback: this[operation.id], self: this };
      });
    }
    if (this.permission != null && this.permission != undefined && this.permission != '') {
      if (this.rowData != null) {
        this.setOperations(this.rowData);
      }
    }
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  //// Advace search Functions
  SearchClear() {
    this.userForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
    });
  }

  AdvanceSearch() {
    var formData = this.userForm.value;
    var searchtext = "0";
    if (
      formData.CODE != null &&
      formData.CODE != undefined &&
      formData.CODE != ""
    )
      searchtext = formData.CODE;

      let model = new AdvModel();
      model.Text = "0";
      model.Type = "A";
      model.AppId = this.appid;
      model.SearchText = searchtext;

    this.summaryService
      .getAuthorizedSigneeSummaryAdvSearch(model)
      .subscribe((summary) => {
        this.rowData = this.setOperations(summary);
      });
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows()
      ? this.gridApi.getSelectedRows()[0]
      : null;
  }

  onRowDoubleClicked(event) {
    let modalRef = this.modalService.open(
      GrantsAuthorizedSigneeAndPayeeViewModalComponent,
      {
        backdrop: false,
        keyboard: false,
        windowClass: "modal-vlg modal-full-height modal-right",
        animation: true,
      }
    );
    modalRef.componentInstance.Content = {
      heading: "Edit",
      content: { id: this.selectedRow["ID"] },
    };
  }

  add() {
    let modalRef = this["self"].modalService.open(
      GrantsAuthorizedSigneeAndPayeeViewModalComponent,
      {
        backdrop: false,
        keyboard: false,
        windowClass: "modal-vlg right modal-right",
        animation: true,
      }
    );
    modalRef.componentInstance.Content = {
      heading: "Add",
      content: { id: "0" },
    };
    modalRef.result.then((result) => {
      this["self"].setSummary();
    });
  }

  edit(RecordData: any) {
    let modalRef = this["self"].modalService.open(
      GrantsAuthorizedSigneeAndPayeeViewModalComponent,
      {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        windowClass: "modal-vlg right modal-right",
        animated: true,
      }
    );
    modalRef.componentInstance.Content = {
      heading: "Edit",
      content: { id: RecordData["ID"] },
    };
    modalRef.result.then((result) => {
      this["self"].setSummary();
    });
  }

  view(RecordData: any)
  {
    let modalRef = this["self"].modalService.open(
      GrantsAuthorizedSigneeAndPayeeViewModalComponent,
      {
        backdrop: false,
        keyboard: false,
        windowClass: "modal-vlg right modal-right",
        animation: true,
      }
    ); 
    modalRef.componentInstance.Content = {
      heading: "View",
      content: { id: RecordData["ID"] },
    };
    modalRef.result.then((result) => {
      this["self"].setSummary();
    });
  }

  delete(RecordData: any) {
    let id = RecordData["ID"];
    let Name = RecordData["NAME"];
    const modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content = {
      heading: "Delete",
      custommessage:
        "Are you sure you want to delete ? ",
      ProceedButtonName: "Delete",
      TerminateButtonName: "Cancel",
    };
    modalRef.result.then((result) => {
      if (result == "okclick") {
        this["self"].summaryService.DeleteSignee(id).subscribe((summary) => {
          if (summary["Status"] == 0) {
            this["self"].commonService.SuccessBanner(this['self'].ScreenName + ' deleted successfully');
            this["self"].setSummary();
          } else {
            this.commonService.ValidationBanner(summary["Message"]);
          }
        });
      }
    });
  }

  make_default(RecordData: any) {
    var id = RecordData["ID"];
    let hasValue = this["self"].rowData.filter(
      (x) => x.DefaultContact.toLowerCase() == "yes" && x.ID != id
    );
    if (hasValue.length > 0) {
      this["self"].commonService.ValidationBanner(
        "Default assignee already exists in this application"
      );
    } else {
      if (RecordData["DefaultContact"].toLowerCase() == "yes") {
        this["self"].commonService.ValidationBanner(
          RecordData["NAME"] +
            "user already marked as Default assignee in this application"
        );
      } else {
        this["self"].summaryService.SigneeDefault(id).subscribe((summary) => {
          if (summary["Status"] == 0) {
            this["self"].commonService.SuccessBanner(summary["Message"]);
            this["self"].setSummary();
          } else {
            this["self"].commonService.ValidationBanner(summary["Message"]);
          }
        });
      }
    }
  }

  setSummary() {
    this.appid = this.commonService.appId;
    let model = new Model();
    model.Text = "0";
    model.Type = "A";
    model.AppId = this.appid

    this.SearchClear();
    this.summaryService
      .getAuthorizedSigneeSummary(model)
      .subscribe((summary) => {
        //this.rowData = summary;
        this.rowData = this.setOperations(summary);
      });
  }

  setOperations(RawData: any): any {
    this.setDef(this.tempoperations);
    RawData.forEach((element) => {
      if (
        this.permission != "view" &&
        element.DefaultContact.toLowerCase() == "yes"
      ) {
        let tempoperations = [
          {
            name: "Edit",
            id: "edit",
          },
          {
            name: "Delete",
            id: "delete",
          }
        ];
        element["Operations"] = this.setDef(tempoperations);
      } else if (
        this.permission != "view" &&
        element.DefaultContact.toLowerCase() != "yes"
      ) {
        let tempoperations = [
          {
            name: "Edit",
            id: "edit",
          },
          {
            name: "Delete",
            id: "delete",
          },
          {
            name: "Make Default Signee",
            id: "make_default",
          }
        ];
        element["Operations"] = this.setDef(tempoperations);
      } else if ((this.permission = "view")) {
        let tempoperations = [
          {
            name: "View",
            id: "view",
          },
        ];
        element["Operations"] = this.setDef(tempoperations);
      }
    });
    return RawData;
  }

  setDef(tempOperations: any): any {
    let operations = tempOperations.map((operation) => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
            name: operation.name,
            callback: this[operation.id],
            self: this,
            disabled: "false",
          }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return operations;
  }

  NavigateToGenInfo() {
    const menu = this.commonService.getModuleMenu();
    if (menu != null) {
      switch (menu.module) {
        case "GRANTSCME":
            this.appid = this.commonService.appId;
            if (this.appid == null || this.appid == undefined || this.appid == "") {
              const modalRefAuth1 = this.modalService.open(MessageBoxComponent, {});
              modalRefAuth1.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Authorized Signer', operation: { hasConfirm: false } } };
              modalRefAuth1.result.then((result) => {
                this.router.navigate(['/home/grants/my-applications/application-ext/:' + 0 + '/geninfocme'],
                  { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants",submodule:menu.module, screen_type: "my-applications" } })
              });
              return false;
            }

          break;
        case "GRANTSSPONSORSHIP":
            this.appid = this.commonService.appId;
            if (this.appid == null || this.appid == undefined || this.appid == "") {
              const modalRefAuth2 = this.modalService.open(MessageBoxComponent, {});
              modalRefAuth2.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Authorized Signer', operation: { hasConfirm: false } } };
              modalRefAuth2.result.then((result) => {
                this.router.navigate(['/home/grants/my-applications/application-ext/:' + 0 + '/genInformsponsorship'],
                  { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants",submodule:menu.module, screen_type: "my-applications" } })
              });
              return false;
            }
          break;
        case "GRANTSCHARITABLE":
          this.appid = this.commonService.appId;
            if (this.appid == null || this.appid == undefined || this.appid == "") {
              const modalRefAuth3 = this.modalService.open(MessageBoxComponent, {});
              modalRefAuth3.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Authorized Signer', operation: { hasConfirm: false } } };
              modalRefAuth3.result.then((result) => {
                this.router.navigate(['/home/grants/my-applications/application-ext/:' + 0 + '/genInformcharitable'],
                  { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants",submodule:menu.module, screen_type: "my-applications" } })
              });
              return false;
            }
          break;
        default:
          break;
      }
    }

  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.appid, '',(ScreenData) => {
      this.ScreenName = ScreenData.NAME;
    });
  }

}
